$('a[href^="/account/logout"]').on('click', function(event){
  event.preventDefault();
  var href = $(this).attr("href"),
      target = '';

  window.sessionStorage.removeItem('savedCharacters');
  // wait for data to push and then open link
  setTimeout(function() { // now wait 150 milliseconds...
      window.open(href,(!target?"_self":target)); // ...and open the link as usual
  },150);

});